import { createApp } from "vue";
import App from "./App.vue";
import { useAccordion } from "vue3-rich-accordion";
// import "vue3-rich-accordion/accordion-library-styles.css";


const app = createApp( App );


app.config.globalProperties.window = window;
//Todo: update on go-live
if ( process.env.NODE_ENV === 'production') {
  // app.config.globalProperties.DOMAIN = 'https://aviahomes3.wpengine.com/';
  app.config.globalProperties.DOMAIN = 'https://aviahomes.com.au/';
}
else {
  app.config.globalProperties.DOMAIN = 'http://val.local/aviahomes';
}
app.config.globalProperties.API_ROOT = app.config.globalProperties.DOMAIN + '/wp-json/avia-cs/v1/';

app.use(useAccordion);
app.mount( '#colour-selector' );
